import React, { ReactElement, ReactNode } from 'react';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash';

import Column from 'components/common/Column';
import {
  SettlementAccountType,
  SettlementsAccountEdges,
} from 'containers/SettlementRequest/graphQL/types';
import Row from 'components/common/Row';
import Text from 'components/common/Text';
import { referredType } from './SettlementTable';
import Divider from 'components/Divider';
import { InView } from 'react-intersection-observer';

interface SettlementDetailListIProps {
  accountItem: SettlementsAccountEdges[];
  hasNextPage: boolean;
  handlePageChange: () => void;
}

const SettlementDetailList: React.FC<SettlementDetailListIProps> = props => {
  const { accountItem, hasNextPage, handlePageChange } = props;

  const renderAccountItem = (
    title: string,
    element: string | ReactElement,
  ): JSX.Element => {
    return (
      <Row justifyContent="space-between" style={{ width: '100%' }}>
        <Text color="#46474C" style={{ minWidth: '50px' }}>
          {title}
        </Text>
        {element}
      </Row>
    );
  };

  return (
    <Column gap="24px">
      {accountItem.map((item, idx) => {
        return (
          <React.Fragment>
            <Column gap="12px" key={idx}>
              {renderAccountItem(
                '구분',
                <Text
                  color={
                    item.node.type === SettlementAccountType.PAYABLE
                      ? '#1B1C1E'
                      : '#FF4242'
                  }
                >
                  {item.node.type === SettlementAccountType.PAYABLE
                    ? '지급'
                    : '회수'}
                </Text>,
              )}
              {renderAccountItem(
                '결제일',
                <Text color="#70737C" weight={400}>
                  {dayjs(item.node.order.transactions[0].firmedAt).format(
                    'YY.M.D(dd)',
                  )}
                </Text>,
              )}
              {renderAccountItem(
                '유형',
                <Text color="#70737C" weight={400}>
                  {referredType[item.node.referredType]}
                </Text>,
              )}
              {renderAccountItem(
                '상품',
                <Column align="flex-end">
                  <Text color="#70737C" weight={400}>
                    {item.node.product === null
                      ? '삭제된 상품입니다.'
                      : item.node.product.listingProductV4.title}
                  </Text>
                  <Text color="#70737C" size="12px" weight={400}>
                    옵션:{' '}
                    {item.node.orderItem?.info?.name ??
                      (!isEmpty(item.node.product.options)
                        ? item.node.product.options[0].names[0]
                        : '')}
                  </Text>
                </Column>,
              )}
              {renderAccountItem(
                '수수료%',
                <Text color="#70737C" weight={400}>
                  {(Number(item.node.commissionFee.value) /
                    (Number(item.node.payment.value) +
                      Number(item.node.commissionFee.value))) *
                    100}
                  %
                </Text>,
              )}
              {renderAccountItem(
                '결제금액',
                <Text
                  color={
                    item.node.type === SettlementAccountType.PAYABLE
                      ? '#70737C'
                      : '#ff4242'
                  }
                  weight={400}
                >
                  {(
                    Number(item.node.payment.value) +
                    Number(item.node.commissionFee.value)
                  ).toLocaleString()}
                  원
                </Text>,
              )}
              {renderAccountItem(
                '수수료',
                <Text color="#70737C" weight={400}>
                  {Number(item.node.commissionFee.value).toLocaleString()}원
                </Text>,
              )}
              {renderAccountItem(
                '지급액',
                <Text color="#70737C" weight={400}>
                  {Number(item.node.payment.value).toLocaleString()}원
                </Text>,
              )}
              {renderAccountItem(
                '구매자',
                <Text color="#70737C" weight={400}>
                  {item.node.order.customer.nickname}
                </Text>,
              )}
            </Column>
            {accountItem.length !== idx + 1 && <Divider />}
          </React.Fragment>
        );
      })}
      <InView
        onChange={InView => {
          if (InView && hasNextPage) {
            handlePageChange();
          }
        }}
      />
    </Column>
  );
};

export default SettlementDetailList;
